import { ProductColor } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import { Table as PDFTable } from '../../components/pdf-export/Table/Table.js';
import { Table as WebTable } from '../../components/table.js';
import { useIsPDF } from '../internal/useIsPDF.js';

type Props = PropsWithChildren<{
  backgroundColor?: ProductColor;
}>;

export function Table(props: Props) {
  const { children, ...rest } = props;
  return useIsPDF() ? (
    <PDFTable {...rest}>{children}</PDFTable>
  ) : (
    <WebTable {...rest}>{children}</WebTable>
  );
}
